export default __webpack_public_path__ + "static/bat_logo-6ac7979217f4c2d9fc0ac55020fee486.png";